import {
  Route,
  RouterProvider,
  Routes,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/index.js";

import { Login } from "./features/authentication/Login.js";
import { Register } from "./features/authentication/Register.js";
import { ForgotPassword } from "./features/authentication/ForgotPassword.js";
import { ValidateForgotPasswordOtp } from "./features/authentication/ValidateForgotPasswordOtp.js";
import { ChangePassword } from "./features/authentication/ChangePassword.js";
import { RequireAuth } from "./config/RequireAuth.js";
import PageNotFound from "./components/PageNotFound.js";
import Unauthorized from "./components/Unauthorized.js";
import UserProfile from "../src/features/authentication/Profile.js";
import Notifications from "./features/notifications/index.js";
import Messages from "./features/messages/index.js";
import SearchResults from "./features/search/SearchResults.js";
import PublicRoute from "./config/PublicRoute.js";
import Home from "./features/ips/Home.jsx";
import MedicalOpinion from "./features/ips/medicalOpinion/index.js";
import VIL from "./features/ips/vil/index.js";
import PatientArrivals from "./features/ips/patientArrivals/index.js";
import MedicalOpinionPatientsList from "./features/ips/medicalOpinion/MedicalOpinionPatientsList.js";
import VilPatientsList from "./features/ips/vil/VilPatientsList.js";
import PatientArrivalsPatientsList from "./features/ips/patientArrivals/PatientArrivalsPatientsList.js";
import PreIntimation from "./features/ips/preIntimation/index.js";
import PreIntimationPatientsList from "./features/ips/preIntimation/PreIntimationPatientsList.js";
import PatientDetails from "./features/ips/components/PatientDetails.js";
import Dashboard from "./features/ips/dashboard/index.js";
import ExistingPatients from "./features/ips/existingPatients/index.js";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {/* Public routes */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/forgot-password/otp"
          element={<ValidateForgotPasswordOtp />}
        />
        <Route path="/change-password" element={<ChangePassword />} />
      </Route>

      {/* Routes with required authentication */}
      <Route
        element={
          <RequireAuth
            allowedRoles={["IPS Executive", "IPS Manager", "IPS Head"]}
          />
        }
      >
        <Route path="/home" element={<Home />} />
        <Route path="/patient" element={<PatientDetails />} />
        <Route path="/medical_opinion" element={<MedicalOpinion />} />

        <Route
          path="/medical_opinion-patient_list"
          element={<MedicalOpinionPatientsList />}
        />
        <Route path="/vil_requests" element={<VIL />} />
        <Route
          path="/vil_requests-patient_list"
          element={<VilPatientsList />}
        />
        <Route path="/patient_arrivals" element={<PatientArrivals />} />
        <Route
          path="/patient_arrivals-patient_list"
          element={<PatientArrivalsPatientsList />}
        />
        <Route path="/pre_intimation" element={<PreIntimation />} />
        <Route path="/existing_patients" element={<ExistingPatients />} />
        <Route
          path="/pre_intimation-patient_list"
          element={<PreIntimationPatientsList />}
        />
        <Route path="dashboard" element={<Dashboard />} />
      </Route>

      <Route element={<RequireAuth />}>
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/search" element={<SearchResults />} />
      </Route>

      {/* Unauthorized route */}
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Fallback route */}
      <Route path="*" element={<PageNotFound />} />
    </Route>
  )
);

function App() {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}

export default App;
